import { render, staticRenderFns } from "./agregar_marca_empresarial.vue?vue&type=template&id=f81dc2e6&scoped=true"
import script from "./agregar_marca_empresarial.vue?vue&type=script&lang=js"
export * from "./agregar_marca_empresarial.vue?vue&type=script&lang=js"
import style0 from "./agregar_marca_empresarial.vue?vue&type=style&index=0&id=f81dc2e6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81dc2e6",
  null
  
)

export default component.exports